import { all } from 'redux-saga/effects';

import consultaAreas from './consultaAreas/saga';
import assuntos from './assuntos/saga';

export default all([consultaAreas, assuntos]);
